import type {
  AdminProgrammeOverview,
  AdminProgrammeOverviewResponse,
  UpdateProgrammeStageBody,
} from '@sparkapp/shared-types';
import { apiRequest } from './apiClient';

type Envelope<T> = { success: true; data: T };

export const programmeApi = {
  async getOverview(): Promise<AdminProgrammeOverviewResponse> {
    return (await apiRequest<Envelope<AdminProgrammeOverviewResponse>>('/v2/admin/programme')).data;
  },

  async changeStage(publicId: string, body: UpdateProgrammeStageBody): Promise<AdminProgrammeOverview> {
    return (
      await apiRequest<Envelope<AdminProgrammeOverview>>(`/v2/admin/programme/${publicId}/stage`, {
        method: 'PATCH',
        body,
      })
    ).data;
  },
};
